import * as Yup from 'yup';

import { validateField, ValidationType } from './formValidation';
import { TicketFormInterface } from 'types';
import { TicketStatus } from 'data/constants/constants';

export const ticketInitialValues: TicketFormInterface = {
    document_id: '',
    status: TicketStatus.PENDING,
    description: '',
    text: '',
    urgency: '',
    assigned_to_id: undefined,
};

export const ticketValidationSchema = Yup.object().shape({
    document_id: validateField(ValidationType.NUMBER),
    text: validateField(ValidationType.STRING),
    description: validateField(ValidationType.STRING, false),
    urgency: validateField(ValidationType.STRING, false),
    assigned_to_id: validateField(ValidationType.STRING, false),
    status: validateField(ValidationType.STRING, false),
});
